import { env } from "@/application/config/env";
import Keycloak, { type KeycloakTokenParsed } from "keycloak-js";
import { ref } from "vue";

const keycloak = new Keycloak({
  url: env.keycloak_url,
  realm: env.keycloak_realm,
  clientId: env.keycloak_client_id,
});

export const isAuthenticated = ref(false);
export const tokenParsed = ref<KeycloakTokenParsed | undefined>();

const sync = () => {
  isAuthenticated.value = !!keycloak.authenticated;
  tokenParsed.value = keycloak.tokenParsed;
};

keycloak.onAuthSuccess = sync;
keycloak.onAuthRefreshSuccess = sync;
keycloak.onAuthLogout = sync;
keycloak.onAuthError = sync;

keycloak.onTokenExpired = () => {
  keycloak
    .updateToken(30)
    .then(sync)
    .catch(() => keycloak.login());
};

let initPromise: Promise<boolean> | null = null;

export const initKeycloak = () => {
  if (!initPromise) {
    initPromise = keycloak
      .init({
        pkceMethod: "S256",
        checkLoginIframe: false,
        onLoad: "check-sso",
        silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
      })
      .then((authenticated) => {
        sync();
        return authenticated;
      });
  }

  return initPromise;
};

export default keycloak;
